<template>
  <draggable
    class="fts-module-designer dragArea"
    tag="div"
    ghost-class="ghost"
    :scroll-sensitivity="200"
    :list="list"
    :value="value"
    @input="emitter"
    @change="change"
    :group="{ name: 'g1' }">
    <div
      class="module"
      v-for="el in realValue.filter((x) => x.module || x.extension || x.type == 'group')"
      :key="el.id">
      <!-- group -->
      <div 
        class="module-wrapper"
        :style="style"
        v-if="el.type == 'group'">
        <div class="module-info">
          <fts-emoji
            class="module-emoji"
            v-model="el.emoji"
            :appendToBody="true"
            :toggleSize="20"
          />
          <fts-contenteditable class="module-contenteditable" v-model="el.name" />
        </div>
      </div>
      <!-- module (menu) -->
      <div
        class="module-wrapper"
        :class="{
          active: el.id == module.id,
          inactive: el.inactive,
          open: el.open,
          unpublished: !el.published
        }"
        :style="style"
        @mouseover="onHover(el, true)"
        @mouseleave="onHover(el)"
        @click="openChildren(el)"
        v-else-if="isGroup(el)">
        <div class="module-info">
          <!-- emoji -->
          <fts-moji :emoji="el.emoji" :size="20" class="module-emoji" v-if="el.emoji" />
          <!-- name -->
          <fts-tippy 
            trigger-class="module-name"
            :options="{arrow: false, placement: 'top-start'}" 
            :content="el.name"
            class="module-name-wrapper">
            <template #trigger>{{el.name}}</template>
          </fts-tippy>
          <!-- profile -->
          <div class="module-tag" v-if="el.isProfile || el.isUserCollection">
            <font-awesome-icon :icon="['fas', 'user']" fixed-width/>
          </div>
        </div>
        <!-- actions -->
        <div class="module-action-container" v-if="el.hover || el.active">
          <!-- design -->
          <fts-btn
            sm
            icon
            color="secondary"
            box-shadow-none
            class="module-action design-toggle stopPropagation"
            @click="selectModule(el)">
            <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" />
          </fts-btn>
          <!-- action dropdown -->
          <fts-dropdown-select
            placement="left-start"
            append-content-class="module-content module-dropdown-menu"
            class="module-action dropdown-toggle"
            :class="{active: el.active}"
            @selected="selectAction($event, el)"
            @show="actionMenuShow(el)"
            @hide="actionMenuHide(el)">
            <fts-btn
              slot="toggle"
              sm
              icon
              color="primary"
              box-shadow-none
              class="stopPropagation">
              <font-awesome-icon :icon="['fas', 'ellipsis-h']" />
            </fts-btn>
            <template #menu="{ select, defaultOptionClass}">
              <div class="module-dropdown-option stopPropagation" :class="defaultOptionClass" @click="select('design')">
                <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" fixed-width class="module-dropdown-option-icon"/>
                <div class="module-dropdown-option-name">Design</div>  
              </div>       
              <div class="module-dropdown-option stopPropagation" :class="defaultOptionClass" @click="select('delete')">
                <font-awesome-icon :icon="['far', 'trash-alt']" fixed-width class="module-dropdown-option-icon"/>
                <div class="module-dropdown-option-name">Delete</div>  
              </div>
            </template>
          </fts-dropdown-select>
        </div>
        <!-- toggle -->
        <font-awesome-icon :icon="['fas', 'caret-right']" fixed-width class="module-toggle" />
      </div>
      <!-- module / menu -->
      <router-link
        :to="{ name: 'studio', query: { id: el.id } }"
        custom
        v-slot="{ href }"
        v-else
      >
        <a
          :href="href"
          :style="style"
          class="module-wrapper"
          :class="{
            active: el.id == module.id,
            inactive: el.inactive,
            unpublished: !el.published
          }"
          @mouseover="onHover(el, true)"
          @mouseleave="onHover(el)"
          @click.prevent="selectModule(el, true)"
        >
          <div class="module-info">
            <!-- emoji -->
            <fts-moji :emoji="el.emoji" :size="20" class="module-emoji" v-if="el.emoji" />
            <!-- name -->
            <fts-tippy
              trigger-class="module-name"
              :options="{arrow: false, placement: 'top-start'}"
              :content="el.name"
              class="module-name-wrapper">
              <template #trigger>{{el.name}}</template>
            </fts-tippy>
            <!-- profile -->
            <div class="module-tag" v-if="el.isProfile || el.isUserCollection">
              <font-awesome-icon :icon="['fas', 'user']" fixed-width/>
            </div>
          </div>
          <!-- actions -->
          <div class="module-action-container" v-if="el.hover || el.active">
            <!-- design -->
            <fts-btn
              sm
              icon
              color="secondary"
              box-shadow-none
              class="module-action design-toggle stopPropagation"
              @click="selectModule(el)">
              <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" />
            </fts-btn>
            <!-- action dropdown -->
            <fts-dropdown-select
              placement="left-start"
              append-content-class="module-content module-dropdown-menu"
              class="module-action dropdown-toggle"
              :class="{active: el.active}"
              @selected="selectAction($event, el)"
              @show="actionMenuShow(el)"
              @hide="actionMenuHide(el)"
            >
              <fts-btn
                slot="toggle"
                sm
                icon
                color="primary"
                box-shadow-none
                class="stopPropagation">
                <font-awesome-icon :icon="['fas', 'ellipsis-h']" />
              </fts-btn>
              <template #menu="{select, defaultOptionClass}">
                <div class="module-dropdown-option stopPropagation" :class="defaultOptionClass" @click="select('design')">
                  <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" fixed-width class="module-dropdown-option-icon"/>
                  <div class="module-dropdown-option-name">Design</div>
                </div>
                <div class="module-dropdown-option stopPropagation" :class="defaultOptionClass" @click="select('delete')">
                  <font-awesome-icon :icon="['far', 'trash-alt']" fixed-width class="module-dropdown-option-icon"/>
                  <div class="module-dropdown-option-name">Delete</div>
                </div>
              </template>
            </fts-dropdown-select>
          </div>
        </a>
      </router-link>
      <!-- module child -->
      <fts-transition-expand :key="el.id" v-if="el.type != 'group'">
        <fts-module
          v-if="el.open"
          mode="design"
          :modules="el.extension.menus"
          child
          :deep="deep + 1"
          :parent-id="el.id"
          :action="el.id === module.id"
          @list="selectList($event)" />
      </fts-transition-expand>
      <!-- group child -->
      <fts-module-designer
        :deep="deep + 1"
        class="recursive"
        v-model="el.children"
        @parentChange="change"
        @listSelected="selectList($event)"
        @moduleSelected="selectModule($event)"
        @deleteModule="deleteModule" />
    </div>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";

import { store as canvasDesignStore } from "../store/canvasDesignStore";
import commons from "../commons/commons";

import FTSContenteditable from "../elements/FTSContenteditable";
import FTSEmoji from "../elements/FTSEmoji";
import FTSMoji from "../elements/FTSMoji";
import FTSProfile from "../elements/FTSProfile";
import FTSModule from "./FTSModule.vue";
import FTSBtn from "../elements/FTSBtn";
import FTSTransitionExpand from "../elements/FTSTransitionExpand";
import FTSDropdownSelect from "../elements/FTSDropdownSelect";
import FTSTippy from "../elements/FTSTippy";

export default {
  name: "fts-module-designer",
  props: {
    value: {
      required: false,
      type: Array,
      default: null,
    },
    list: {
      required: false,
      type: Array,
      default: null,
    },
    deep: {
      type: Number,
      default: 0,
    },
  },
  components: {
    "fts-contenteditable": FTSContenteditable,
    "fts-emoji": FTSEmoji,
    "fts-moji": FTSMoji,
    "fts-profile": FTSProfile,
    "fts-module": FTSModule,
    "fts-btn": FTSBtn,
    "fts-dropdown-select": FTSDropdownSelect,
    "fts-transition-expand": FTSTransitionExpand,
    "fts-tippy": FTSTippy,
    draggable,
  },
  computed: {
    realValue() {
      return this.value ? this.value : (this.list? this.list : []);
    },
    style() {
      if (this.deep)
        return {
          "padding-left": `calc(${this.deep * 25}px + ${
            this.deep * 0.575
          }rem + 1rem)`,
        };
    },
    module() {
      return canvasDesignStore.state.vector || {};
    },
  },
  methods: {
    isGroup(item) {
      return item.extension && item.extension.menus && item.extension.menus.length
    },
    selectList(item) {
      this.$emit('listSelected', item);
    },
    emitter(value) {
      this.$emit("input", value);
    },
    selectModule(item, stopPropagation) {
      if (commons.elementStopPropagation() && stopPropagation) return

      if (!item.type && item.id)
        this.$emit("moduleSelected", item);
    },
    deleteModule(item) {
      this.$emit("deleteModule", item)
    },
    onHover(item, visible) {
      if (visible)
        this.$set(item, "hover", true)
      else
        this.$delete(item, "hover")
    },
    openChildren(item) {
      if (commons.elementStopPropagation()) return
      
      if (item.open === undefined) 
        this.$set(item, "open", true);
      else 
        item.open = !item.open;
    },
    async selectAction(arg, item) {
      if (arg === 'design') {
        this.selectModule(item)
      } else if (arg === 'delete') { 
        this.$emit("deleteModule", item)
      }
    },
    actionMenuShow(item) {
      this.$set(item, 'active', true)
    },
    actionMenuHide(item) {
      this.$delete(item, 'active')
    },
    findGroupName(menus, i) {
      let name = `Group ${i}`;
      if (menus.some((x) => x.name == name)) {
        return this.findGroupName(menus, i + 1);
      } else {
        return name;
      }
    },
    recursiveProcess(original) {
      let menus = [...original];
      menus.forEach((item) => {
        if (item.children && item.children.length) {
          var modules = item.children.filter((x) => x.module);
          if (modules.length) {
            this.recursiveProcess(item.children);

            if (item.type != "group" && modules.length) {
              let index = original.indexOf(item);
              var children = item.children.filter((x) => !x.module && x.id);

              original.splice(index, 1, {
                id: commons.nanoID(),
                name: this.findGroupName(original, 1),
                type: "group",
                children: [...modules, item],
                emoji: "⚪",
              });
              item.children = children;
            }
          }
        } else if (item.type == "group") {
          let index = original.indexOf(item);
          original.splice(index, 1);
        }
      });
    },
    change(event) {
      this.recursiveProcess(this.value);
      if(this.value && this.value.length == 0) {
        this.$emit('parentChange');
      }
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-module-designer {
  // draggable
  &.recursive {
    min-height: 0.375rem;
    .ghost {
      &::before {
        content: "drop to form a group";
      }
    }
  }
  .ghost {
    background-color: rgb(56, 82, 155);
    &::before {
      display: inline-block;
      text-align: center;
      color: rgba(236, 236, 236, 0.466);
      content: "drop here to rearrange";
      width: 100%;
      padding: 3px;
      font-size: smaller;
    }
  }
  // module
  .module-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    text-decoration: unset;
    color: var(--drawer);
    transition: background 0.3s ease-in-out;
    cursor: pointer;
    &.open {
      .module-toggle {
        transform: rotate(90deg);
      }
    }
    &:hover {
      background: var(--drawer-hover-background);
      color: var(--drawer-hover);
    }
    &.active {
      background: var(--drawer-active-background);
      color: var(--drawer-active);
    }
    &.inactive {
      .module-info {
        .module-emoji {
          filter: grayscale(1);
        }
        .module-name {
          color: var(--fts-gray-5);
        }
      }
    }
    .module-info {
      min-width: 0;
      flex: 1;
      display: flex;
      align-items: center;
      .module-emoji {
        margin-right: 0.575rem;
      }
      .module-name-wrapper {
        min-width: 0;
        .module-name {
          @include text-overflow-ellipsis;
          font-size: 1.15rem;
        }
      }
      .module-contenteditable {
        font-size: 1.15rem;
      }
      .module-tag {
        margin-left: .575rem;
        padding: .1rem .175rem;
        font-size: .675rem;
        border-radius: .25rem;
        background: var(--drawer-secondary-background);
        color: var(--drawer-secondary);
      }
    }
    .module-action-container {
      position: absolute;
      right: 1rem;
      display: flex;
      align-items: center;
      .module-action {
        &:not(:first-child) {
          margin-left: .575rem;
        }
        &.active {
          z-index: 2;
        }
        z-index: 1;
      }
    }
    .module-toggle {
      margin-left: .575rem;
      color: inherit;
      transition: all 0.3s;
    }

    &.unpublished {
      opacity: 0.5;
    }
  }
}
// module dropdown menu
.module-content.module-dropdown-menu {
  width: 120px;
  .module-dropdown-option {
    min-width: 0;
    display: flex;
    align-items: center;
    .module-dropdown-option-icon {
      margin-right: .575rem;
      color: var(--fts-gray-5);
    }
    .module-dropdown-option-name {
      @include text-overflow-ellipsis;
    }
  }
}
</style>